module.exports = __webpack_public_path__ + "static/media/indicators.0ed1ebfb.svg";